import React from "react";
import ReactDOM from "react-dom/client";
import { WagmiProvider } from "wagmi";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/sonner";
import "@/index.css";
import "@/web3";
import { wagmiConfig } from "@/web3";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, refetchOnWindowFocus: false },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <WagmiProvider config={wagmiConfig}>
      <QueryClientProvider client={queryClient}>
        <App />
        <Toaster
          position="bottom-right"
          theme="dark"
          toastOptions={{ style: { background: "#131824", border: "1px solid rgba(255,255,255,0.1)", color: "#f8fafc" } }}
        />
      </QueryClientProvider>
    </WagmiProvider>
  </React.StrictMode>,
);
